export const COPY_ROOT = 'gig_page_perseus.contact_seller_options';
